let host = location.host;
let TestSite = ['aemtest.com', 'store-rev.modd.com'];

$(function () {
    var $body = $('body');
    var bodyId = $body.attr('id');
    if (bodyId === "fc_contact") {
        fc_contact();
    }
    else if (bodyId === "fc_help") {
        fc_help();
    }
    else if (bodyId === "fcJoin") {
        fcJoin();
    }
    else if (bodyId === "Login") {
        Login();
    }
    else if (bodyId === "FcCard") {
        FcCard();
    }
    else if (bodyId === "fcJoinEntry") {
        fcJoinEntry();
    }
    else if (bodyId === "fcJoinConf") {
        fcJoinConf();
    }
});

function fc_contact() {
    $(".col-xs-12.t_message").each(function () {
    if ($(this).text().indexOf('お電話でのお問い合わせ') > -1) {
        $(this).remove();
        }
    };

    $("#support_txt .btn-100").text('FAQ');
    $("#support_txt .btn-100").attr('href', 'https://hio-miyazawa.dev06.axdv.me/faq/');

    var $panel_contact = $('#panel_contact');
    var domList = $('.tblbody_contact_note');
    var dom1 = domList[0];
    var dom2 = domList[1];
    dom1.remove();
    $panel_contact.append('<div class="table_body tblbody_contact_note"><div class="table_label col_must"><a href="/v2/help/fc_kiyaku.aspx?ccode=LMZH" class="underline link--white">利用規約</a>に同意する</div><div class="table_control"><div style="margin-bottom:10px"><a href="/v2/help/fc_kiyaku.aspx?ccode=LMZH" target="_blank" class="underline">利用規約</a>にご同意の上、入力してください。</div><input required="required" name="利用規約に同意する" value="はい" aria-required="true" type="checkbox">同意する</div></div>');
}
function fc_help() {
    $(".t_title").text('FAQ');
}
function fcJoin() {
    $("#kiyaku_lbl a").addClass('link');
}
function FcCard() {
    $(".t_title").after('※カード情報の登録をおこなうと自動で継続処理がおこなわれます。<br>自動継続を停止する場合はカード情報の削除をおこなってください。')
}
function Login() {
    $(".fc_register_table").remove();
}
function fcJoinEntry() {
    var params = location.search;
    if (params.indexOf('fcm=LMZH') > -1) {
        $('#card_fc_auto').prop('checked', true);
    };
    $(".tblbody_joinamount").remove();
    $(".tblbody_feeamount").remove();

    $("#card_member").attr('placeholder', 'カード番号は半角でご入力ください');
}
function fcJoinConf() {
    $(".tblbody_joinamount").remove();
    $(".tblbody_feeamaount").remove();
}